import { configureStore } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // uses localStorage
import userReducer from './Slices/userSlice';
import symbolReducer from './Slices/symbolSlice'
import modalReducer from './Slices/modalSlice'
import { combineReducers } from 'redux';
import newsReducer from './Slices/newsSlice'
import accountReducer from './Slices/accountTree'
import orderPositionReducer from './Slices/orderPositionSlice';
import watchListReducer from './Slices/watchList';
import emailReducer from './Slices/emailsSlice';
import alertReducer from './Slices/alertSlice';
import accountSummaryReducer from './Slices/accountSummary'
import symbolGroupUnitReducer from './Slices/symbolGroupUnitSlice';
import globalSymbolReducer from './Slices/globalSymbolSlice';
import profitLossReducer from './Slices/profitLossSlice';
import updateSymdol from './Slices/updateSymbol'
import historyReducer from './Slices/historySlice'
import priceChangeReducer from './Slices/priceChange'
import amountReducer from './Slices/amountSlice';
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user', "symbol", "watchlist", "amount"]
};

const rootReducer = combineReducers({
  user: userReducer,
  symbol: symbolReducer,
  modal: modalReducer,
  news: newsReducer,
  accountTree: accountReducer,
  orderPosition: orderPositionReducer,
  watchlist: watchListReducer,
  email: emailReducer,
  alert: alertReducer,
  accountSummary: accountSummaryReducer,
  groupUnit: symbolGroupUnitReducer,
  globalSymbol: globalSymbolReducer,
  profitLoss: profitLossReducer,
  updateSymbol: updateSymdol,
  history:historyReducer,
  priceChange: priceChangeReducer,
  amount: amountReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
});

const persistor = persistStore(store);

export { store, persistor };